const orderTypeMap = { ordinary: 0, other: 1, partner: 2, web: 3, onlineSales: 4 };

export default orderTypeMap;
